/*
 * October 2026: the free-gift threshold engine (FREE_GIFT_MODE, FREE_GIFT_THRESHOLDS, the
 * DKK 2,500 progress logic, auto add / remove of a 0 DKK bag, ?drawstring=open handling) was
 * removed from this file. The rebuilt gift pop-up lives in snippets/gift-floating-button.liquid
 * and assets/gift-popup.js.
 */
// Header Swatch
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".color-slider");
  const nextBtn = document.querySelector(".color-nav.next");
  const prevBtn = document.querySelector(".color-nav.prev");
  const sliderWraper = document.querySelector(".color-slider-wrapper");

  if (!slider || !nextBtn || !prevBtn) return;

  const scrollAmount = 72;

  function updateButtons() {
    const maxScrollLeft = slider.scrollWidth - slider.clientWidth;

    // LEFT
    if (slider.scrollLeft <= 2) {
      prevBtn.classList.add("hidden");
      sliderWraper.classList.add("hide-prev");
    } else {
      prevBtn.classList.remove("hidden");
      sliderWraper.classList.remove("hide-prev");
    }

    // RIGHT
    if (slider.scrollLeft >= maxScrollLeft - 2) {
      nextBtn.classList.add("hidden");
      sliderWraper.classList.add("hide-next");
    } else {
      nextBtn.classList.remove("hidden");
     sliderWraper.classList.remove("hide-next");
    }
  }

  function checkOverflow() {
    const hasOverflow = slider.scrollWidth > slider.clientWidth + 2;

    if (hasOverflow) {
      nextBtn.classList.remove("hidden");
      slider.classList.remove("hide-next");
    } else {
      nextBtn.classList.add("hidden");
      prevBtn.classList.add("hidden");
      slider.classList.remove("hide-prev");
      slider.classList.remove("hide-next");
    }
  }

  function init() {
    checkOverflow();
    updateButtons();
  }

  nextBtn.addEventListener("click", () => {
    slider.scrollBy({ left: scrollAmount, behavior: "smooth" });
  });

  prevBtn.addEventListener("click", () => {
    slider.scrollBy({ left: -scrollAmount, behavior: "smooth" });
  });

  slider.addEventListener("scroll", updateButtons);

  // ✅ ONLY ONE reliable init trigger
  window.addEventListener("load", () => {
    init();
  });

  // ✅ Resize fix
  window.addEventListener("resize", init);

  // ✅ BEST FIX (handles image load + layout changes perfectly)
  // const observer = new ResizeObserver(() => {
  //   init();
  // });

  // observer.observe(slider);

}); 


// New Product Template Tabs
document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".product-tabs-component").forEach((component) => {

    const nav = component.querySelector("[data-tabs-nav]");
    const content = component.querySelector("[data-tabs-content]");

    if (!nav || !content) return;

    const items = content.querySelectorAll(".product-tab-item");

    items.forEach((item, index) => {

      const button = item.querySelector(".product-tab-pill");
      const panel = item.querySelector(".product-tab-panel");

      if (!button || !panel) return;

      // Move pills into top nav
      nav.appendChild(button);

      // First active
      if (index === 0) {

        button.classList.add("active");
        button.setAttribute("aria-selected", "true");
        button.setAttribute("tabindex", "0");

        panel.classList.add("active");
        panel.hidden = false;

      } else {

        button.setAttribute("aria-selected", "false");
        button.setAttribute("tabindex", "-1");

        panel.hidden = true;

      }

      button.addEventListener("click", () => {

        const targetId = button.dataset.tabTrigger;

        // Reset buttons
        nav.querySelectorAll(".product-tab-pill").forEach((pill) => {

          pill.classList.remove("active");
          pill.setAttribute("aria-selected", "false");
          pill.setAttribute("tabindex", "-1");

        });

        // Reset panels
        content.querySelectorAll(".product-tab-panel").forEach((tabPanel) => {

          tabPanel.classList.remove("active");
          tabPanel.hidden = true;

        });

        // Active button
        button.classList.add("active");
        button.setAttribute("aria-selected", "true");
        button.setAttribute("tabindex", "0");

        // Active panel
        const activePanel = content.querySelector(`#${targetId}`);

        if (activePanel) {

          activePanel.classList.add("active");
          activePanel.hidden = false;

        }

        // Smooth scroll active pill
        button.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest"
        });

      });

      // Keyboard support
      button.addEventListener("keydown", (event) => {

        const tabs = [...nav.querySelectorAll(".product-tab-pill")];

        const currentIndex = tabs.indexOf(button);

        let nextIndex = currentIndex;

        switch (event.key) {

          case "ArrowRight":
            nextIndex = (currentIndex + 1) % tabs.length;
            break;

          case "ArrowLeft":
            nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
            break;

          case "Home":
            nextIndex = 0;
            break;

          case "End":
            nextIndex = tabs.length - 1;
            break;

          default:
            return;

        }

        event.preventDefault();

        tabs[nextIndex].focus();
        tabs[nextIndex].click();

      });

    });

    // Mouse wheel horizontal scroll
    nav.addEventListener("wheel", (event) => {

      if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {

        event.preventDefault();

        nav.scrollLeft += event.deltaY;

      }

    }, { passive: false });

    component.classList.add("tabs-ready");

  });

});


/*
 * HB 2026-10-08: the "Delivery Dates" block that lived here (a second copy of the script in
 * snippets/delivery-estimate.liquid) was removed. Two copies wrote the same cart line and, once the
 * cart line started to depend on the cart total, they overwrote each other without end and froze the
 * page. The delivery line is computed in one place only, snippets/delivery-estimate.liquid.
 */

// Toggle sticky gift button visibility based on section scroll position
const targetSection = document.querySelector(
  '.content-for-layout .section-wrapper:last-child'
);

const giftButton = document.querySelector('.gift-floating-btn');

if (targetSection && giftButton) {
  new IntersectionObserver(([entry]) => {
    giftButton.classList.toggle('is-active', entry.isIntersecting);
  }, {
    threshold: 0
  }).observe(targetSection);
}

document.querySelector('.facets--horizontal')?.addEventListener('click', function (e) {
  e.stopPropagation();
  this.classList.toggle('is-active');
});

function removeCheckedClassIfNoFilter() {
  if (!window.location.search.includes('filter')) {
    document
      .querySelectorAll('.mega-menu__list_color li.is-checked')
      .forEach((item) => item.classList.remove('is-checked'));
  }
}
function getCookie(name) {
  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    const [cookieName, ...cookieValue] = cookie.trim().split('=');

    if (cookieName === name) {
      return decodeURIComponent(cookieValue.join('='));
    }
  }

  return null;
}

window.addEventListener('load', function () {
  setTimeout(function () {
    document.querySelectorAll('.lazy-video').forEach(function (video) {
      if (video.dataset.src) {
        const source = document.createElement('source');
        source.src = video.dataset.src;
        source.type = 'video/mp4';

        video.appendChild(source);
        video.load();
        video.play().catch(() => {});
      }
    });

    const videos = document.querySelectorAll('.js-autoplay-video');
    let hasPlayed = false; // ✅ guard flag

    const playAllVideos = () => {
      if (hasPlayed) return; // 🚫 prevent multiple calls
      hasPlayed = true;

      videos.forEach(video => {
        video.play().catch(() => {});
      });
    };

    // First user interaction anywhere
    document.addEventListener('touchstart', playAllVideos, { once: true });
    document.addEventListener('click', playAllVideos, { once: true });
  }, 1500);




});



